import * as types from './constants';

// Get Notifications
export const getNotificationsRequest = data => (
  { type: types.GET_NOTIFICATIONS_REQUEST, payload: data }
);

export const getNotificationsDone = data => (
  { type: types.GET_NOTIFICATIONS_DONE, payload: data }
);

export const getNotificationsFailed = errors => (
  { type: types.GET_NOTIFICATIONS_FAILED, payload: errors }
);

// Operations
export const setFilter = data => (
  { type: types.SET_NOTIFICATIONS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_NOTIFICATIONS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_NOTIFICATIONS_FILTERS, payload: { filterToUpdate, mobile } }
);